import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
export const CloseButton = (props)=>{
    const { className, onClick, white, type = 'button', ...rest } = props;
    const bsClass = classnames('btn-close', {
        ['btn-close-white']: !!white
    }, className);
    return /*#__PURE__*/ _jsx("button", {
        ...rest,
        type: type,
        "aria-label": "Close",
        onClick: onClick,
        className: bsClass
    });
};
